import { render, staticRenderFns } from "./CategoriasTable.vue?vue&type=template&id=eb30ce50&"
import script from "./CategoriasTable.vue?vue&type=script&lang=js&"
export * from "./CategoriasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports